import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { store } from './store/store';
import i18n from './i18n';
import App from './App';
import { ThemeProvider } from './components/ThemeProvider';

// Styles
import './index.css';
import 'react-quill/dist/quill.snow.css';
//import './chart';

// Constants
const MOUNT_NODE = document.getElementById('root');

// Root Component
const AppWrapper = () => (
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </I18nextProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// Root Rendering
const root = createRoot(MOUNT_NODE);
root.render(<AppWrapper />);

// Performance Monitoring
/* if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} */